import about1 from '../assets/about1.jpg'

export default function About() {
  return (
  <div className="container">   
    <div className="page">
      <section>
        <h2 className='align_center'>      
          About us
        </h2>
      </section> 
  
      <div className="align_left" >

        We are an Australian-owned and operated business primarily focused on the development and commercialisation of new technologies.<br />
        The company was founded by professionals with experience in clean technology and power generation.<br />
        We focus on the developing new methods for energy conversion from both renewable and conventional energy sources.<br />
        Our products generate clean power, save fuel, and reduce CO₂ emissions.<br />
        <br />

      </div>     
      <img src={about1} alt='' />    
    </div>
  </div>
)}
